var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapStory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7903 38.4587L35.0945 15.5686C35.3352 15.0811 35.8319 14.7725 36.3756 14.7725H46.8019C47.9188 14.7725 48.6039 15.9963 48.0199 16.9483L40.0261 29.9814C39.4422 30.9335 40.1272 32.1573 41.2441 32.1573H46.3243C47.5322 32.1573 48.1951 33.5632 47.4266 34.4952L28.6164 57.3056C27.5783 58.5645 25.581 57.38 26.1877 55.8653L31.5488 42.4803C31.9247 41.5417 31.2335 40.5203 30.2224 40.5203H25.0714C24.0123 40.5203 23.3213 39.4083 23.7903 38.4587Z",
    fill: "url(#paint0_linear_7568_3688)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.2722,
    cy: 35.2725,
    r: 33.5,
    stroke: "url(#paint1_linear_7568_3688)",
    strokeWidth: 3.5443,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7568_3688",
    x1: 40.0933,
    y1: 14.7725,
    x2: 26.1602,
    y2: 64.3545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD3790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#248ECC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7568_3688",
    x1: 35.8427,
    y1: 1.77246,
    x2: 35.8427,
    y2: 68.7725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#803AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475962,
    stopColor: "#EA489A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8F3E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapStory);
export default __webpack_public_path__ + "static/media/zap-story.1b05f0d52996bc45ad153996443fa23e.svg";
export { ForwardRef as ReactComponent };